import store from '@/store'

import { version } from '@/version'
import raygun from '@/plugins/raygun'
import { DSB_API_EXCEPTION } from '@/plugins/errorCodes'

export default {
	install(Vue) {
		Vue.use(raygun, {
			key: process.env.VUE_APP_RAYGUN_KEY,
			version: version
		})

		Vue.config.errorHandler = function(error, vm) {
			if (JSON.parse(error.message).responseBody) {
				if (
					JSON.parse(error.message).responseBody.exceptionType &&
					JSON.parse(error.message).responseBody.exceptionType.includes('DSBApiException')
				) {
					Vue.prototype.$sendError({
						name: 'DSBApiException',
						error: error
					})
					window.location.href = '/payment/error?code=' + DSB_API_EXCEPTION

					return
				}
			}

			const componentName = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name

			store.commit('error/setError', {
				hard: true,
				details: {
					message: error ? (typeof error === 'string' ? error : error.message) : null,
					source: componentName,
					stack: error ? error.stack || error.stacktrace || null : null
				}
			})

			// Raygun
			Vue.prototype.$sendError({
				error
			})
		}

		window.onunhandledrejection = function({ reason, type }) {
			store.commit('error/setError', {
				hard: true,
				details: {
					message: reason ? (typeof reason === 'string' ? reason : reason.message) : null,
					source: type,
					stack: reason ? reason.stack || reason.stacktrace || null : null
				}
			})

			// Raygun
			Vue.prototype.$sendError({
				error: reason
			})
		}

		window.onerror = function(message, source, _lineno, _colno, error) {
			if (JSON.parse(error.message).responseBody) {
				if (
					JSON.parse(error.message).responseBody.exceptionType &&
					JSON.parse(error.message).responseBody.exceptionType.includes('DSBApiException')
				) {
					Vue.prototype.$sendError({
						name: 'DSBApiException',
						error: error
					})
					window.location.href = '/payment/error?code=' + DSB_API_EXCEPTION

					return
				}
			}

			if (message === 'Script error.') {
				// Script error is the error that is thrown when cross-domain errors occur
				// https://blog.sentry.io/2016/05/17/what-is-script-error
				// https://raygun.com/blog/script-error/
				//
				// Do not block the UI, as the user probably still can continue, as the only
				// cross domain script being used is third party tracking scripts
				//
				// Still send them to Raygun, so we get some kind of stat we can show the customers
			} else {
				store.commit('error/setError', {
					hard: true,
					details: {
						message: message,
						source: source,
						stack: error === null ? null : error.stack || error.stacktrace || null
					}
				})
			}

			// Raygun
			Vue.prototype.$sendError({
				error
			})
		}
	}
}
